export class AppException extends Error {
    public constructor(message: string) {
        super(message);
    }
}
